import {
    fetchCustomersTypes,
    fetchCustomers,
    fetchMyCustomers,
    updateMyCustomers
} from "@/api/index";
import i18n from "@/i18n";
import { isEqual, sortBy } from "lodash";

export const state = {
    customersTypes: [],
    customers: [],
    myCustomers: [],
    temp: null
};
export const getters = {
    myCustomersOriginal: ({ myCustomers, temp }) => temp || myCustomers,
    customersTableRow: ({ customers }, { myCustomersOriginal }) =>
        customers.reduce((acc, { id, name }) => {
            if (!myCustomersOriginal.find(item => item.name === name)) {
                const cells = [{ text: name }];
                acc.push({ cells, id: String(id) });
            }
            return acc;
        }, []),
    myCustomersTableRow: (state, { myCustomersOriginal }) =>
        myCustomersOriginal.map(({ id, name }) => {
            const cells = [{ text: name }];
            return { cells, id: String(id) };
        }),
    customersModified: ({ myCustomers, temp }) =>
        !!temp && !isEqual(sortBy(myCustomers, "id"), sortBy(temp, "id"))
};
export const actions = {
    async FETCH_CUSTOMERS_TYPES({ commit, dispatch }) {
        try {
            const { data } = await fetchCustomersTypes();
            commit("SET_CUSTOMERS_TYPES", data);
        } catch (e) {
            dispatch("UPDATE_ERROR_SNACKBAR", e);
        }
    },
    async FETCH_CUSTOMERS({ commit }, params) {
        try {
            const { data } = await fetchCustomers(params.type && params);
            commit("SET_CUSTOMERS", data);
        } catch (e) {
            //
        }
    },
    async FETCH_MY_CUSTOMERS({
        commit,
        rootState: { route: { params: { aId: appId } } }
    }) {
        try {
            const { data } = await fetchMyCustomers(appId);
            commit("SET_MY_CUSTOMERS", data);
        } catch (e) {
            //
        }
    },
    async CANCEL_CUSTOMERS_UPDATE({
        getters: { customersModified },
        dispatch,
        commit
    }) {
        if (!customersModified) return true;
        const action = await dispatch("UPDATE_DIALOG", {
            ...i18n.t("appDetail.customers.cancelUpdate"),
            actions: [
                { action: "cancel", label: i18n.t("label.cancel") },
                { action: "confirm", label: i18n.t("label.confirm") }
            ]
        });
        if (action === "confirm") {
            commit("RESET_TEMP_CUSTOMERS");
            return true;
        }
        return false;
    },
    async UPDATE_MY_CUSTOMERS({
        getters: { myCustomersOriginal, customersModified },
        commit,
        dispatch,
        rootState: { route: { params: { aId: appId } } }
    }) {
        if (!customersModified) return;
        if (!myCustomersOriginal.length) {
            dispatch("UPDATE_DIALOG", {
                ...i18n.t("appDetail.customers.notModified"),
                actions: [{ action: "confirm", label: i18n.t("label.confirm") }]
            });
            return;
        }
        try {
            await updateMyCustomers(appId, myCustomersOriginal);
            await dispatch("FETCH_MY_CUSTOMERS");
            commit("RESET_TEMP_CUSTOMERS");
            dispatch("UPDATE_SNACKBAR", {
                message: i18n.t("appDetail.customers.saveUpdate")
            });
        } catch (e) {
            dispatch("UPDATE_ERROR_SNACKBAR", e);
        }
    }
};
export const mutations = {
    SET_CUSTOMERS_TYPES(state, value) {
        state.customersTypes = value;
    },
    SET_CUSTOMERS(state, value) {
        state.customers = value;
    },
    SET_MY_CUSTOMERS(state, value) {
        state.myCustomers = value;
    },
    PATCH_TEMP_CUSTOMERS(state, value) {
        state.temp = value;
    },
    RESET_TEMP_CUSTOMERS(state) {
        state.temp = null;
    },
    RESET_CUSTOMERS(state) {
        state.customersTypes = [];
        state.customers = [];
        state.myCustomers = [];
        state.temp = null;
    }
};
